import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import style from './style.module.scss';

const TableTotalStatisticsSkeleton = () => {
  return [...Array(6)].map(() => (
    <tr key={uuidv4()}>
      {[...Array(5)].map(() => (
        <td key={uuidv4()}>
          <SkeletonBlock className={style.skeletonText} />
        </td>
      ))}
    </tr>
  ));
};

export default TableTotalStatisticsSkeleton;
